// extracted by mini-css-extract-plugin
export default {"list":"products_list__aJV2r"};